import React from "react"

const Footer = ({}) => (<>
    <footer>
        <div className="container-fluid">
            <div className="row justify-content-between">
                <div className="col-auto p-0">
                    <ul className="footer__social">
                        <li><a rel="noreferrer" className="fs" target="_blank" href="https://www.behance.net/aboutluca">BEHANCE</a></li>
                        <li><a rel="noreferrer" className="fs" target="_blank" href="https://twitter.com/aboutluca">TWITTER</a></li>
                        <li><a rel="noreferrer" className="fs" target="_blank" href="https://it.linkedin.com/in/luca-nardi-512947137">LINKEDIN</a></li>
                    </ul>
                </div>
                <div className="col-auto footer__y d-flex align-items-center">
                    @2021
                </div>
            </div>
        </div>
    </footer>
</>)

export default Footer
